import * as constants from "./constants";
import * as irConstants from "./site/insuranceranked";
import * as tcrConstants from "./site/thecreditreview";

export const customBehaviorByPathsWithFilter = {
	[constants.TCR_DOMAIN]: {
		[tcrConstants.PERSONAL_LOANS_DEFAULT_PATH]: {
			[constants.CUSTOM_MAIN_BENEFITS_FIELD_BY_UI_FILTERING]: {
				[tcrConstants.POOR_CREDIT_QUALITY_FILTERING_VALUE]:
					"poorCreditCompanyMainBenefits",
			},
			[constants.CUSTOM_RATING_KEY_BY_UI_FILTERING]: {
				[tcrConstants.POOR_CREDIT_QUALITY_FILTERING_VALUE]: "badCreditRating",
				[tcrConstants.FAIR_CREDIT_QUALITY_FILTERING_VALUE]: "fairCreditRating",
				[tcrConstants.GOOD_CREDIT_QUALITY_FILTERING_VALUE]: "goodCreditRating",
				[tcrConstants.EXCELLENT_CREDIT_QUALITY_FILTERING_VALUE]:
					"excellentCreditRating",
			},
			[tcrConstants.FAST_LOANS_CREDIT_QUALITY_URL_PARAMETER]: {
				[constants.CUSTOM_MAIN_BENEFITS_FIELD]: "poorCreditCompanyMainBenefits",
			},
			[tcrConstants.QUICK_LOANS_CREDIT_QUALITY_URL_PARAMETER]: {
				[constants.CUSTOM_MAIN_BENEFITS_FIELD]: "poorCreditCompanyMainBenefits",
			},
			[tcrConstants.EMERGENCY_LOANS_CREDIT_QUALITY_URL_PARAMETER]: {
				[constants.CUSTOM_MAIN_BENEFITS_FIELD]: "poorCreditCompanyMainBenefits",
			},
			[tcrConstants.BAD_CREDIT_QUALITY_URL_PARAMETER]: {
				[constants.CUSTOM_MAIN_BENEFITS_FIELD]: "poorCreditCompanyMainBenefits",
			},
			[tcrConstants.ONE_THOUSAND_LOAN_AMOUNT_URL_PARAMETER]: {
				[constants.CUSTOM_MAIN_BENEFITS_FIELD]: "poorCreditCompanyMainBenefits",
			},
		},
	},
	[constants.IR_DOMAIN]: {
		[irConstants.IR_LIFE_INSURANCE_DEFAULT_PATH]: {
			[constants.CUSTOM_RATING_KEY_BY_UI_FILTERING]: {
				[irConstants.AGED_FILTERING_KEY]: "overAge50Rating",
			},
		},
		[irConstants.IR_PET_INSURANCE_DEFAULT_PATH]: {
			"dog-insurance": {
				[constants.CUSTOM_RATING_KEY]: "dogInsuranceRating",
			},
		},
	},
};

export const customBehaviorByMobileTargetedPath = {
	[constants.IR_DOMAIN]: {
		[irConstants.IR_LIFE_INSURANCE_DEFAULT_PATH]: {
			[constants.CUSTOM_MAIN_BENEFITS_FIELD]: "mobileCompanyMainBenefits",
		},
	},
};
